'use strict';

class OriginatorSelect {
  constructor($location, $window, originatorService, I18N) {
    this.$location = $location;
    this.$window = $window;
    this.originatorService = originatorService;
    this.I18N = I18N;
  }

  $onInit() {
    this.alert = {};

    if (this.originators.total === 0) {
      this.alert = {
        type: 'error',
        message: this.I18N.originator.noAccess
      };
    }
  }

  select(originator) {
    if (originator && originator.id) {
      this.originatorService.select(originator.id)
        .then(() => {
          this.$window.sessionStorage.setItem('originatorId', originator.id);

          if (originator.state === 'CLOSED_RETURN_MAIL') {
            // STATE 8
            this.$location.path('/konto/bekreft').search('error', 'adresse');
          } else if (originator.state === 'CLOSED_WRONG_EMAIL') {
            // STATE 6
            this.$location.path('/konto/bekreft').search('error', 'epost');
          } else {
            this.$location.path('/beslutning-kreves');
          }
        });
    } else {
      this.$location.path('/konto/registrer');
    }
  }
}

OriginatorSelect.$inject = ['$location', '$window', 'originatorService', 'I18N'];

const originatorSelect = {
  bindings: {
    originators: '<'
  },
  controller: OriginatorSelect,
  template: `
    <alert data="$ctrl.alert" />

    <div class="row">
      <div class="large-8 columns">
        <h2>Velg konto</h2>
      </div>

      <div class="large-4 columns search-input" ng-show="$ctrl.originators.items.length > 1">
        <i class="fa fa-search"></i>
        <input type="search" ng-model="$ctrl.q" placeholder="Filtrer">
      </div>
    </div>

    <div class="row">
      <originator-panel class="large-4 columns" ng-repeat="originator in $ctrl.originators.items | filter: $ctrl.q track by originator.id" data="originator" />

      <div class="large-4 columns left">
        <div class="panel" ng-click="$ctrl.select()">
          <div class="row">
            <div class="large-4 small-4 columns center-align">
              <i class="fa fa-plus"></i>
            </div>

            <div class="large-8 small-8 columns">
              <h4>Registrer ny konto</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('originatorSelect', originatorSelect)
  .config(($routeProvider) => {
    $routeProvider
      .when('/bytt-konto', {
        title: 'Velg konto',
        template: '<originator-select originators="$resolve.originators" />',
        resolve: {
          originators: (userService) => userService.getLinkedOriginators().then((resp) => resp.data)
        },
        noSidebar: true,
        noNav: true,
        noNotification: true,
        secure: true
      });
  });
